export default "__VITE_ASSET__Bwfs7Gwu__"